function regular(string) {
	if (!string) return "";
	var Chars = "0123456789.,/\-";
	var news = "";

	for (var i = 0; i < string.length; i++) {
			if (Chars.indexOf(string.charAt(i)) == -1) {
					void (null);
			} else {
					news = news + string.charAt(i);
			}
	}
	return news;
}

function numberFormat(el) {
	var number = el.value.replace(/\s/gi, "");
	if (number.length > 3 && (number.indexOf('.') == -1) ) {
			var mod = number.length % 3;
			var output = (mod > 0 ? (number.substring(0, mod)) : "");
			for (i = 0; i < Math.floor(number.length / 3); i++) {
					if ((mod == 0) && (i == 0))
							output += number.substring(mod + 3 * i, mod + 3 * i + 3);
					else
							output += " " + number.substring(mod + 3 * i, mod + 3 * i + 3);
			}
			el.value = output;
	} else el.value = number;
}

function numberFormatValue(value) {
	var number = value.toString().replace(/\s/gi, "");
	if (number.length > 3) {
			var mod = number.length % 3;
			var output = (mod > 0 ? (number.substring(0, mod)) : "");
			for (i = 0; i < Math.floor(number.length / 3); i++) {
					if ((mod == 0) && (i == 0))
							output += number.substring(mod + 3 * i, mod + 3 * i + 3);
					else
							output += " " + number.substring(mod + 3 * i, mod + 3 * i + 3);
			}
			return output;
	} else return number;
}

function recaptchaOnload() {
	var recaptchaList = document.querySelectorAll('.js-recaptcha');

	if (recaptchaList.length) {
		recaptchaList.forEach(function(item) {
			var recaptchaId = grecaptcha.render(item, { 'sitekey' : item.dataset.sitekey });
			item.recaptchaId = recaptchaId;
		});
	}
}

/*
*	Common functions
*/
document.addEventListener('DOMContentLoaded', function(){
	
	/*
	* Show hidden elements
	*/
	document.addEventListener('click', function(e){
		var target = e.target;
		
		if (!target.closest('.hidden__link')){
			return;
		}

		var wrp = target.closest('.hidden');
		
		var hl = wrp.querySelectorAll('.hidden__link');
		for (var i=0; i<hl.length; i++){
			hl[i].style.display = 'none';
		}

		var hi = wrp.querySelectorAll('.hidden__item');
		for (var i=0; i<hi.length; i++){
			hi[i].classList.remove('hidden__item');
		}
	});


	/*
	* POPUPS 2019
	*/
	var popups19 = document.querySelectorAll('.popup19');
	
	if (popups19.length){

		var //popups19CloseBtn = document.querySelectorAll('.popup19__close-btn, [data-close-popup19]'),
				popup19SubmitBtns = document.querySelectorAll('.popup19 .btn--submit');

		// Close popup when click on close btn, or click outside popup
		document.addEventListener('click', function(e){
			var tg = e.target;

			if (tg.classList.contains('popup19')){
				
				if (tg.hasAttribute('data-delete')){
					tg.remove();
				} else {
					tg.style.display = 'none';
				}

				document.body.style.overflow = '';
			}
		});
		
		document.addEventListener('click', function(e){
			var tg = e.target;
			if (tg.classList.contains('popup19__close-btn') || tg.hasAttribute('data-close-popup19')){
				var popup = tg.closest('.popup19');
				
				if (popup.hasAttribute('data-delete')){
					popup.remove();
				} else {
					popup.style.display = 'none';
				}

				document.body.style.overflow = '';
			}
		});

		// open popups
		// var container = document.querySelector("[data-container]");

		// var popup19OpenBtns = document.querySelectorAll('[data-popup-target]');
		// for (var i=0; i<popup19OpenBtns.length; i++){
			// popup19OpenBtns[i].addEventListener('click', function(e){
				document.addEventListener('click', function(e) {
				var popup19OpenBtn = e.target.closest('[data-popup-target]');

				if (!popup19OpenBtn) {
					return;
				}

				e.preventDefault();
				e.stopPropagation();

				document.querySelector('.'+popup19OpenBtn.dataset.popupTarget).style.display = '';

				return false;
			});
		// }

		// validate and submit form
		for (var i=0; i<popup19SubmitBtns.length; i++){
			popup19SubmitBtns[i].addEventListener('click', function(){
				var btn = this,
						input = btn.closest('.popup19__row').querySelector('.input-line__input'),
						form = btn.closest('form');
				
				if (!input.value || !input.value.match(/.+@.+\..+/i)){
					input.classList.add('input-line__input--error');
					return;
				}

				var request = new XMLHttpRequest();
				request.open(form.getAttribute('method'), form.getAttribute('action'), true);
				request.onreadystatechange = function () {
					if (this.readyState != 4) return;

					var resp = JSON.parse(this.response);

					if (!resp.err) {
						btn.remove();

						var p = document.createElement('p');
						p.innerHTML = resp.msg;
						p.classList.add('popup19__result-text')
						form.append(p);
						input.disabled = true;

					} else {
						console.log(form.getAttribute('action')+' error: '+resp.msg)
						btn.disabled = false;
					}
				};

				request.onerror = function () {
					console.log(form.getAttribute('action')+' connection error');
					btn.disabled = false;
				};

				btn.disabled = true;
				var fd = new FormData(form);
				request.send(fd);
			});
		}
	}


	/*
	* INPUT FILES
	*/

	/* Photo previews
	*
	* Min width height sould be MIN_WIDTH_HEIGHT.
	* But if you don't want to check size, then put 'data-donot-check-size' attribute on photo input
	*
	*/
	var MIN_WIDTH_HEIGHT = 600,
			photoInputs = Array.prototype.slice.call( document.querySelectorAll('.input-line__photo-input') ),
			fileDelBtns = Array.prototype.slice.call( document.querySelectorAll('.input-line__photo-del-btn') );

	if (photoInputs.length){

		function deleteFile(el){
			var wrp = el.closest('.input-line__photo');
			wrp.style.backgroundImage = '';
			wrp.classList.remove('input-line__photo--loaded');

			wrp.querySelector('input').value = null;
		}
		
		function makeThumbnail(el){

			var error = document.querySelector('.input-line__photo--error');
			if (error){
				error.classList.remove('input-line__photo--error');
			}

			var input = el,
					preview = input.closest('label'),
					reader = new FileReader();

			reader.onload = function (e) {
				var img = new Image();

				img.onload = function (e) {

					if (!el.hasAttribute('data-donot-check-size')){

						// if hasn't then check min size
						if ( (this.width >= MIN_WIDTH_HEIGHT) || (this.height >= MIN_WIDTH_HEIGHT) ){
							preview.style.backgroundImage = 'url(' + reader.result + ')';
							preview.classList.add('input-line__photo--loaded');
						} else {
							preview.classList.add('input-line__photo--error')
							deleteFile(input);
						}
					} else {
						preview.style.backgroundImage = 'url(' + reader.result + ')';
						preview.classList.add('input-line__photo--loaded');
					}
				}

				img.src = reader.result;
			};

			reader.readAsDataURL(el.files[0]);
		}

		// Create preview
		photoInputs.forEach(function(photoInput){
			photoInput.addEventListener('change', function () {
				makeThumbnail(this);
			});
		})

		// Delete photos by del btn
		fileDelBtns.forEach(function(fileDelBtn){
			fileDelBtn.addEventListener('click', function(){
				deleteFile(this);
			});
		})

	}


	/*
	* Change password
	*/
	function createError(msg){
		var err = document.createElement('p');
		err.classList.add('error-text');
		err.textContent = msg;
		return err;
	}

	function clearErrors(){
		var oldError = document.querySelector('.error-text');
		if (oldError) {
			oldError.remove();
		}

		var oldErrorList = document.querySelector('.error-list');
		if (oldErrorList) {
			oldErrorList.style.display = 'none';
		}
	}

	var changePassBtn = document.querySelector('.btn-change-password');
	if (changePassBtn) {
		changePassBtn.addEventListener('click', function(){

			clearErrors();

			var oldPass = document.querySelector('input[name="old-password"]');
			if (!oldPass.value){
				var td = oldPass.closest('td');
				td.append(createError(oldPass.dataset.empty));
				return;
			}

			var newPass = document.querySelector('input[name="new-password"]');
			if (!newPass.value){
				var td = newPass.closest('td');
				td.append(createError(newPass.dataset.empty));
				return;
			}

			/*
			* (?=.{6,})  		length greater than 8
			* (?=.*\d)  		at least one digit
			* (?=.*[a-z])   at least one lowercase characters
			* (?=.*[A-Z])  	at least one uppercase characters
			*/
			var regular = /.*^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.{6,}).*$/;
			if (!regular.test(newPass.value)){
				var td = newPass.closest('td');
				td.querySelector('.error-list').style.display = 'block';
				return;
			}

			var checkNewPass = document.querySelector('input[name="new-password-check"]');
			if (!checkNewPass.value) {
				var td = checkNewPass.closest('td');
				td.append(createError(checkNewPass.dataset.empty));
				return;
			}

			if (checkNewPass.value != newPass.value) {
				var td = checkNewPass.closest('td');
				td.append(createError(checkNewPass.dataset.equal));
				return;
			}

			var state = changePassBtn.innerHTML;
			var request = new XMLHttpRequest();
			request.open('post', './data/changePassword.json', true);
			request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded; charset=utf-8');

			request.onreadystatechange = function () {
				if (this.readyState != 4) return;

				var resp = JSON.parse(this.response);

				// Make p with text
				var p = document.createElement('p'),
						pWrp = changePassBtn.parentElement;
						p.innerHTML = resp.msg;


				if (!resp.err) {
					p.classList.add('success-text');
					changePassBtn.remove();
				} else {
					p.classList.add('error-text');
					changePassBtn.disabled = false;
					changePassBtn.innerHTML = changePassBtn.state;
				}
				
				pWrp.appendChild(p);
			};

			request.onerror = function () {
				console.error('Change password: connection error');
				changePassBtn.disabled = false;
				changePassBtn.innerHTML = state;
			};

			changePassBtn.disabled = true;
			changePassBtn.innerHTML = changePassBtn.dataset.wait;

			var data = '';
			data += "oldPassword=" + oldPass.value;
			data += "&newPassword=" + newPass.value;
			data += "&newPasswordCheck=" + checkNewPass.value;
			request.send(data);
		});
	}

	/*
	* Checklist switching
	*/
	var checklistItems = document.querySelectorAll('button.checklist__item');
	if (checklistItems.length) {
		[].forEach.call(checklistItems, function(item){

			item.addEventListener('click', function(){

				if (this.classList.contains('checklist__item--active')) {
					this.classList.remove('checklist__item--active');
					return;
				}

				var checkList = this.closest('.checklist'),
						input = checkList.querySelector('.checklist__input'),
						active = checkList.querySelector('.checklist__item--active');
				
				input.value = this.dataset.value;
				if (active) {
					active.classList.remove('checklist__item--active');
				}
					
				this.classList.add('checklist__item--active');
			});
		})
	}


	/*
	* Change active class in search form tabs.
	* Can't place it in search-form-2018.js because they are elso in sidebar block
	*/
	var searchFormTabs = document.querySelectorAll('.dealid');
	[].forEach.call(searchFormTabs, function(tab){
		tab.addEventListener('click', function(){
			var tabsWrp = this.parentElement,
					formWrp = tabsWrp.parentElement,
					targetInput = formWrp.querySelector('input[name="dealid"]');

			// Change value
			targetInput.value = this.dataset.value;

			var event = new Event('change');
			targetInput.dispatchEvent(event);

			// Change class
			tabsWrp.querySelector('.active').classList.remove('active');
			this.classList.add('active');
		});
	});

	//Ввод в текстовое поле только цифр
	var numInputs = document.querySelectorAll('.only-num');
	[].forEach.call(numInputs, function(numInput){

		numInput.addEventListener('input', function () {
			this.value = regular(this.value);
		});

		numInput.addEventListener('change', function (e) {
			var value = parseFloat(this.value.replace(/\s/g, ''));

			if (this.hasAttribute('data-min')) {
				var	min = parseInt(this.dataset.min),
						max = parseInt(this.dataset.max);

				if ( value < min ){
					this.value = min;
				}
				if ( value > max ){
					this.value = max;
				}
			}
			
			numberFormat(this);
		});

	});


	/*
	* Input line
	* Input text and range slider connection
	*/
	document.addEventListener('change', function(e){
		var range = e.target.closest('.input-line__range');
		
		
		if (range) {
			
			var targetInput = range.previousElementSibling;

			if (targetInput) {
				targetInput.value = range.value;

				var event = new CustomEvent('change', {
					"bubbles":true,
					"detail": { handmade: true }
				});
				targetInput.dispatchEvent(event);
			}

			return;
		}
		
		var input = e.target.closest('.input-line__input');
		if (input && !e.detail) {
			var targetRange = input.nextElementSibling;
			if (targetRange) {

				if (targetRange.hasAttribute('min')) {
					if (input.value < targetRange.min) {
						input.value = targetRange.min;
					}
				}

				if (targetRange.hasAttribute('max')) {
					if (input.value > targetRange.max) {
						input.value = targetRange.max;
					}
				}

				targetRange.value = parseFloat(input.value.replace(/\s/g, ''));
			}

			var event = new CustomEvent('change', {
				"bubbles":true,
				"detail": { handmade: true }
			});
			input.dispatchEvent(event);
		}
	});


	//init all telephone inputs
	var telephoneInputs = Array.prototype.slice.call(document.querySelectorAll('input[name="tel"][data-not-inited], [data-input-tel][data-not-inited]'));
	telephoneInputs.forEach(function(telephoneInput){
		IMask(telephoneInput, {
			mask: '+{7}(000)000-00-00'
		});
	});


	var allDocBtn = document.querySelector('.popup19--send-docs .btn');
	if (allDocBtn) {
		var form = allDocBtn.closest('form'),
				inputTel = form.querySelector('.input-line__input--tel'),
				state = allDocBtn.textContent;
		allDocBtn.addEventListener('click', function(e){

				e.preventDefault();
				// checking repeating symbols more 10 times
        var telPhone = inputTel.value.replace(/\D/gi, '');

				if (inputTel.value.length < 16 || !!telPhone.match(/(?=(.))\1{10,}/g)) {
					inputTel.classList.add('input-line__input--error')
					return;
				}
				
				var request = new XMLHttpRequest();
				request.open(form.getAttribute('method'), form.getAttribute('action'), true);
				request.onreadystatechange = function () {
						if (this.readyState != 4) return;

						var resp = JSON.parse(this.response);

						if (!resp.err) {
								var p = document.createElement('p');
								p.classList.add('popup19__result-text');
								p.textContent = resp.msg;
								form.appendChild(p);
						} else {
								allDocBtn.disabled = false;
						}

						allDocBtn.textContent = state;
						
				};

				request.onerror = function () {
						console.log(form.getAttribute('action') + ' connection error');
						allDocBtn.textContent = state;
						allDocBtn.disabled = false;
				};

				allDocBtn.disabled = true;
				allDocBtn.textContent = allDocBtn.dataset.wait;
				
				var data = new FormData(form);
				request.send(data);
		});
	}


	var accXs = document.querySelectorAll('.acc-xs__button');

	accXs.forEach(function(btn){
		btn.addEventListener('click', function () {
			var parent = btn.closest('.acc-xs'),
					panel = btn.nextElementSibling;
			
			parent.classList.toggle('acc-xs--opened');

			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
			} else {
				panel.style.maxHeight = panel.scrollHeight + "px";
			}
		});
	});
});


/*
* Form validation
*/
document.addEventListener('DOMContentLoaded', function(){
	var form = document.querySelector('form.js-simple-submit');
	if (!form) {
		return;
	}

	var requireElements = form.querySelectorAll('[required]'),
			submitBtn = form.querySelector('.js-btn-submit'),
			agreeCheck = form.querySelector('.js-form-check-rules'),
			state = submitBtn.textContent;

	function clearFormErrors() {
		var texts = form.querySelectorAll('.input-line__error-text:not(.hidden)');
		texts.forEach(function(text){
			text.classList.add('hidden');
		});

		var styles = form.querySelectorAll('.has-error');
		styles.forEach(function(style){
			style.classList.remove('has-error');
		});
	}

	function removeSingleErrorNode(){
		var isErrorNode = this.classList.contains('has-error');

		if (isErrorNode) {
			this.classList.remove('has-error');
			var errorText = this.closest('.input-line').querySelector('.input-line__error-text');
			if (errorText) {
				errorText.classList.add('hidden');
			}
		}
	}

	function scrollToFirstError() {
		var errEl = form.querySelector('.has-error');

		if (errEl) {
			errEl.closest('.input-line').scrollIntoView({
				behavior: 'smooth'
			});
		}
	}

	requireElements.forEach(function(el){
		el.addEventListener('input', removeSingleErrorNode);
		el.addEventListener('change', removeSingleErrorNode);
	});
		
	form.addEventListener('submit', function(e){
		e.preventDefault();

		clearFormErrors();

		var bError = false;
		requireElements.forEach(function(el){
			
			if (!el.checkValidity()) {
				var errorType = el.validity.valueMissing ? 'valueMissing' : 'valueInvalid';
				var errorEl = el.closest('.input-line').querySelector('.input-line__error-text');
				if (errorEl) {
					errorEl.innerHTML = el.dataset[errorType];
					errorEl.classList.remove('hidden');
				}
				el.classList.add('has-error');

				bError = true;
			}
		});
		
		if (bError) {
			scrollToFirstError();
			return;
		}

		var request = new XMLHttpRequest(),
				enctype = 'application/x-www-form-urlencoded; charset=utf-8';
		request.responseType = 'json';
		request.open(form.getAttribute('method'), form.getAttribute('action'), true);
		if (form.hasAttribute('enctype')) {
			enctype = form.getAttribute('enctype');
		}
		request.setRequestHeader('Content-type', enctype);

		request.addEventListener('readystatechange', function (e) {

			if (request.readyState === 4 && request.status === 200) {

				if (!this.response.err) {

					if (this.response.elementsToHideInSuccess) {
						this.response.elementsToHideInSuccess.forEach(function(selector){
							var el = document.querySelector(selector);
							el.style.display = 'none';
						})
					}
					
					if (this.response.successHtml) {
						var successTarget = document.querySelector(this.response.successTarget);
						successTarget.innerHTML = this.response.successHtml;
						successTarget.style.display = '';
					}

					if (0) {
						var p = document.createElement('p');
						p.classList.add('feedback__text-success');
						p.textContent = this.response.elements[0].message;
						feedbackForm.appendChild(p);
					}
				} else {

					this.response.elements.forEach(function(el){
						var errEl = document.querySelector('[name="'+el.errName+'"]');
						if (errEl) {
							errEl.classList.add('has-error');
							var errText = errEl.closest('.input-line').querySelector('.input-line__error-text');
							errText.textContent = el.message;
							errText.classList.remove('hidden');
						}
					});

					scrollToFirstError();
					submitBtn.disabled = false;
				}

				submitBtn.textContent = state;
			}
		});

		submitBtn.disabled = true;
		submitBtn.textContent = submitBtn.dataset.wait;

		var data = new FormData(form);
		request.send(data);
	});

	agreeCheck.addEventListener('change', function() {
		submitBtn.disabled = !this.checked;
	});
});

/*
* Header functions
*/
document.addEventListener('DOMContentLoaded', function(){

	// 
	// Поиск регионов на пк
	//

	// // Подгрузка выпадающего меню с регионами
	// var regionsBtn = document.querySelector('.h-menu__item--region')
	// 		regionsContainer = document.querySelector('.h-menu__regions-container');
	// regionsBtn.addEventListener('mouseover', function(){

	// 	var request = new XMLHttpRequest();
	// 		request.open('get', './data/header-regions.html', true);
	// 		request.onreadystatechange = function () {
	// 			if (this.readyState != 4) return;

	// 			regionsContainer.innerHTML = this.response;
	// 		};

	// 		request.onerror = function () {
	// 			console.log('getting headerRegions connection error');
	// 		};

	// 		request.send();
	// },{once : true});

	// // Очистка выбранных вариантов
	// var clearBtn = document.getElementById('clearAfterSearch');
	// if (clearBtn){
	// 	clearBtn.addEventListener('click', function(){

	// 		inputAutoSearch.value = '';
	// 		cleanSelect();
	// 	});
	// }

	// // Отображение по поиску
	// var inputAutoSearch = document.querySelector('input[name="HAS"]'),
	// 	varList = document.querySelectorAll('.h-menu__item--region .h-menu__sub_menu li:not(.search-line)');

	// function cleanSelect(){

	// 	for (var i=0; i<varList.length; i++){
	// 		varList[i].style.display = '';
	// 	};
	// }

	// inputAutoSearch.addEventListener('keyup', function(){

	// 	if (inputAutoSearch.value == ''){
	// 		cleanSelect();
	// 	}
		
	// 	for (var i=0; i<varList.length; i++){

	// 		var item = varList[i];
			
	// 		if (item.querySelector('a').innerHTML.toLowerCase().indexOf(inputAutoSearch.value.toLowerCase()) == -1 ){
	// 			item.style.display = 'none';
	// 		} else {
	// 			item.style.display = '';
	// 		}
	// 	};
	// });

	// 
	// Открытие всплывающего меню на мобильнике
	// 
	var burgerOpen = document.querySelector('.rl__burger'),
		burgerClose = document.querySelectorAll('.mm__close, [data-close-mm]');
	var mobileMenu = document.querySelector('.h__mobile-menu');

	burgerOpen.addEventListener('click', function(){

		bodyScrollLock.disableBodyScroll(mobileMenu);
		mobileMenu.classList.add('mm--opened');

	});

	burgerClose.forEach(function(item){
		
		item.addEventListener('click', function(){

			bodyScrollLock.enableBodyScroll(mobileMenu);
			mobileMenu.classList.remove('mm--opened');
		});
	})

	// 
	// раскрытие меню личного кабинета
	// 
	var lk = document.querySelector('.rl__icon-wrp--lk');
	if (lk){
		lk.addEventListener('click', function(){
			this.classList.toggle('rl__icon-wrp--opened');
		});
	}

	// 
	// Фиксирование шапки при прокрутке
	// Теперь в common.js
	//
	// var lastScrollTop = 0,
	// 	header = document.querySelector('.h');

	// if (header !== null){
	// 	window.onscroll = function() {requestAnimationFrame(stickFunc)};
	// }

	// var sticky = 0;

	// function stickFunc() {

	// 	sticky = header.offsetTop;

	// 	var st = window.pageYOffset;

	// 	if (st > lastScrollTop){

	// 		// Scroll Down
	// 		sticky += header.clientHeight;

	// 		header.classList.add('h--nav-down')
	// 		header.classList.remove('h--nav-up');
	// 	} else {

	// 		// Scroll Up
	// 		header.classList.add('h--nav-up')
	// 		header.classList.remove('h--nav-down');
	// 	}
	// 	lastScrollTop = st;

	// 	if (window.pageYOffset >= sticky) {
	// 		header.classList.add('h--sticky');
	// 	} else {
	// 		header.classList.remove('h--sticky');
	// 	}
	// }

	
	// Picking region
	var regionsAll,
			request = new XMLHttpRequest(),
			regionsList = document.querySelector('.region-list'),
			regionSearchLine = document.querySelector('input[name="region-search"]');

	function drawRegions(regions) {

		regionsList.innerHTML = '';

		regions.forEach(function(region){
			
			var li = document.createElement('div');
			li.classList.add('region-list__item');

			if (region.hasOwnProperty('name')) {
				var area = document.createElement('div');
				area.classList.add('region-list__area');

				var areaLink = document.createElement('a');
				areaLink.classList.add('link', 'link--grey');
				areaLink.href = region.url;
				areaLink.textContent = region.name;
				areaLink.setAttribute('data-action', region.action);
				areaLink.setAttribute('data-region', region.id);
				area.appendChild(areaLink);

				li.appendChild(area);
			}			

			var citiesList = document.createElement('ul');
			citiesList.classList.add('region-list__cities');
			
			region.items.forEach(function(subreg){
				
				var citiesLi = document.createElement('li');
				citiesLi.classList.add('region-list__city');

				var cityLink = document.createElement('a');
				cityLink.classList.add('link', 'link--grey');
				cityLink.href = subreg.url;
				cityLink.textContent = subreg.name;
				cityLink.setAttribute('data-action', subreg.action);
				cityLink.setAttribute('data-region', subreg.id);
				citiesLi.appendChild(cityLink);

				citiesList.appendChild(citiesLi);
			})
			
			if (citiesList.hasChildNodes()){
				li.appendChild(citiesList);
			}

			if (li.hasChildNodes()){
				regionsList.appendChild(li);
			}
		});
	}

	if (regionSearchLine) {
		regionSearchLine.addEventListener('input', function(){
			var val = this.value.trim(),
					filteredRegions = [];
	
			regionsAll.forEach(function(region){
				var filteredRegion = {};
	
				if (region.name.toLowerCase().indexOf(val.toLowerCase()) != -1) {
					filteredRegion.name = region.name;
					filteredRegion.url = region.url;
					filteredRegion.id = region.id;
					filteredRegion.action = region.action;
				}
	
				filteredRegion.items = [];
				region.items.forEach(function(city){
					if (city.name.toLowerCase().indexOf(val.toLowerCase()) != -1) {
						filteredRegion.items.push(city);
					}
				})
	
				filteredRegions.push(filteredRegion);
			});
	
			drawRegions(filteredRegions);
		});
		

		request.open('get', 'https://www.restate.ru/siteforms/getcities/', true);
		request.onreadystatechange = function () {
			if (this.readyState != 4) return;

			var resp = JSON.parse(this.response);
			regionsAll = resp.regions;
			drawRegions(regionsAll);
		};

		request.onerror = function () {
			console.log('get cities: connection error');
			submitBtn.disabled = false;
		};

		request.send();
	}
});


/*
* Открытие всплывашек в формах лидов
*/
document.addEventListener('DOMContentLoaded', function(){
	var popup = document.querySelector('.leadform19__win'),
			leadFormWillLoad = document.querySelector('[data-leadform-will-load]');
	
	if (!popup && !leadFormWillLoad){
		return;
	}

	// Открытие
	var leadBtns = document.querySelectorAll('[data-leadform-open-popup]');
	for (var i=0; i<leadBtns.length; i++){
		var btn = leadBtns[i];

		btn.addEventListener('click', function(){
			var popup = this.closest('.leadform19').querySelector('.leadform19__popup');
			popup.classList.add('leadform19__popup--active');
		});
	}

	// Закрытие
	var leadPopup = document.querySelectorAll('.leadform19__popup');
	var leadBtnClose = document.querySelectorAll('.leadform19__close');

	for (var i=0; i<leadPopup.length; i++){
		var popup = leadPopup[i];
		popup.addEventListener('click', function(e){

			if (!e.target.classList.contains('leadform19__popup')){
				return;
			}
			
			this.classList.remove('leadform19__popup--active');
		});
	}

	for (var i=0; i<leadBtnClose.length; i++){
		var btn = leadBtnClose[i];
		btn.addEventListener('click', function(){
			var form = this.closest('.leadform19__popup');
			form.classList.remove('leadform19__popup--active');
		});
	}

	// Инициализация селекта
	var roomCount = document.querySelector('.leadform19__input [name="roomcount"]');
	if (roomCount){
		var selectRoomCount = new vanillaSelectBox('.leadform19__input [name="roomcount"]', {
			"maxHeight": 200
		});
	}

	var telephoneInputs = Array.prototype.slice.call(document.querySelectorAll('.leadform19__win input[name="tel"]'));
	telephoneInputs.forEach(function(telephoneInput){
		IMask(telephoneInput, {
			mask: '+{7}(000)000-00-00'
		});
	});

	// Валидирование формы
	// var submitBtns = Array.prototype.slice.call(document.querySelectorAll('[data-need-to-validate-form]'));
	
	// submitBtns.forEach(function(submitBtn){

		document.addEventListener('click', function(e){
			var submitBtn =  e.target.closest('[data-need-to-validate-form]');

			if (!submitBtn) {
				return;
			}
			
			var form = submitBtn.closest('form'),
					inputs = form.querySelectorAll('input[required], input[type="email"]'),
					selects = form.querySelectorAll('select[required]'),
					closeBtnForm = document.querySelector('.form-wrp__close'),
					gallery = document.querySelector('.js-main-slider'),
					wrapper = submitBtn.closest('.form-wrp'),
					recaptchaForm = form.querySelector('.js-recaptcha');
			
			var error = form.querySelector('.input-line__input--error');
			if (error){
				error.classList.remove('input-line__input--error');
			}

			var errorText = form.querySelector('.error-text');
			if (errorText){
				errorText.remove();
			}
			
			for (var i=0; i < inputs.length; i++){
				if (inputs[i].required && !inputs[i].value){
					inputs[i].classList.add('input-line__input--error');
					return;
				}

				// Не работает на лидовой форме, возможно имелась ввиду другая проверка
				// if (inputs[i].getAttribute('name') === 'first-name') {
				// 	inputs[i].classList.add('input-line__input--error');
				// 	return;
				// }

				if ( (inputs[i].getAttribute('name') === 'tel') && (inputs[i].value.length < 16)){
					inputs[i].classList.add('input-line__input--error');
					return;
				}

				if ( inputs[i].value && (inputs[i].getAttribute('type') === 'email') && (!inputs[i].value.match(/.+@.+\..+/i)) ) {
					inputs[i].classList.add('input-line__input--error');
					return;
				}
			}

			for (var i=0; i<selects.length; i++){
				if (!selects[i].value){
					selects[i].closest('.input-line').querySelector('.vsb-main').classList.add('vsb-main--error');
					return;
				}
			}

			// validate Recaptcha
			if (recaptchaForm) {
				function isRecapthchaValid(recaptchaForm) { 
					var recaptchaId = recaptchaForm.recaptchaId;
					
					var responseRecaptcha = grecaptcha.getResponse(recaptchaId);
					return responseRecaptcha.length;
				}
	
				if (!isRecapthchaValid(recaptchaForm)) {
					var container = submitBtn.parentElement;
					var errorText = document.createElement('p');
					errorText.classList.add('error-text');
					errorText.textContent = recaptchaForm.dataset.errorText;

					container.appendChild(errorText);
					return;
				}
			}

			var leadForm = document.getElementById("form-lead");
			var eventData = leadForm.dataset.event;

			var request = new XMLHttpRequest();
			request.open(form.getAttribute('method'), form.getAttribute('action'), true);
			request.onreadystatechange = function () {
				if (this.readyState != 4) return;

				var resp = JSON.parse(this.response);

				if (!resp.err) {
					wrapper.querySelector('.form-wrp__state').style.display = 'none';
					wrapper.querySelector('.form-wrp__result').style.display = 'block';
				} else {
					var p = document.createElement('p');
					p.classList.add('error-text');
					p.textContent = resp.msg;
					submitBtn.parentNode.insertBefore(p, submitBtn.nextSibling);

					submitBtn.disabled = false;
				}
			};

			request.onerror = function () {
				console.log(form.getAttribute('action')+' connection error');
				submitBtn.disabled = false;
			};

			submitBtn.disabled = true;

			if ( (typeof dataLayer)  != 'undefined') {
				dataLayer.push({'event': eventData});
			};

			var fd = new FormData(form);
			fd.append('data', eventData);
			request.send(fd);

			if(gallery) {
				gallery.addEventListener('click', function(){
					wrapper.querySelector('.form-wrp__state').style.display = 'block';
					wrapper.querySelector('.form-wrp__result').style.display = 'none';
					submitBtn.disabled = false;
				});
			}

			if(closeBtnForm) {
				closeBtnForm.addEventListener('click', function(){
					wrapper.querySelector('.form-wrp__state').style.display = 'block';
					wrapper.querySelector('.form-wrp__result').style.display = 'none';
					submitBtn.disabled = false;
				});
			}
		});
	// });
});


/*
* .realtors-slider init
*/
document.addEventListener('DOMContentLoaded', function(){
	var slider = document.querySelector('.realtors-slider');
	if (!slider) {
		return;
	}

	new Swiper(slider.querySelector('.swiper-container'), {
		speed: 400,
		spaceBetween: 30,
		freeMode: true,
		slidesPerView: 'auto',
		navigation: {
			nextEl: slider.querySelector('.slider-button--next'),
			prevEl: slider.querySelector('.slider-button--prev'),
			disabledClass: 'slider-button--disabled'
		}
	});
});

document.addEventListener('DOMContentLoaded', function() {
	function isTouchDevice() {
		var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
		
		var mq = function (query) {
				return window.matchMedia(query).matches;
		}
	
		if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
				return true;
		}
	
		var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
		return mq(query);
	};
	
	// show popover
	var popover = document.querySelector('.popover__box');
	if (popover) {
		document.body.addEventListener("mouseleave", function(event) {
			popover.classList.add('popover__box--slide-down')
		});

		var cancelBtns = popover.querySelectorAll('.popover-btn');
		for (var i=0; i<cancelBtns.length; i++){
			cancelBtns[i].addEventListener('click', function(event) {
				popover.remove();
			});
		}

		if (isTouchDevice()){
			setTimeout(function(){
				popover.classList.add('popover__box--slide-down')
			}, 5000)
		}
	};
});


// Sidebar fixing
window.addEventListener('load', function(){

	var sidebar = document.querySelector('aside');

	if (!sidebar) {
		return;
	}

	var mainContainer = document.querySelector('.main-content_t2017_2');

	// fix page jumping when sidebar is higher than main part
	if (mainContainer && (mainContainer.scrollHeight < sidebar.scrollHeight) ) {
		return;
	}

	var footer = document.querySelector('footer'),
			footerOffset = footer.scrollHeight,
			sidebarBottom = sidebar.scrollHeight + sidebar.getBoundingClientRect().top + window.scrollY + footerOffset;

	sidebar.style.bottom = footerOffset + 'px';

	window.addEventListener('scroll', function(){

		if (window.innerWidth > 1019) {
			
			var scroll = window.scrollY + window.innerHeight;
			if (scroll > sidebarBottom) {
				sidebar.style.position = 'fixed';
			} else {
				sidebar.style.position = '';
			}
		}
	});

	// Mutation observer
	var config = { attributes: false, childList: true, subtree: true };

	var callback = function(mutationsList, observer) {
    sidebarBottom = sidebar.scrollHeight + sidebar.getBoundingClientRect().top + window.scrollY + footerOffset;
	};

	var observer = new MutationObserver(callback);
	observer.observe(sidebar, config);
});
